import { MpsReadDBConnectionType, ReadDBConnectionType, WritePoolType } from '../../../shared/database/db';
import { ProductsMemberships } from '../../../entities/pool/public/products_memberships';
import { ProductListTypeS } from '../../ProductList/outbound/share';
import { MembershipProductType } from './type';
import { Products } from '../../../entities/pool/public/products';

export const MEMBERSHIP_PRODUCTS_FETCH_TYPE = {
  USER: 'USER',
  CREATOR: 'CREATOR',
} as const;

/**
 * 멤버십 상품목록 "필터" 옵션. 해당 옵션으로 데이터를 거른다.
 */
export interface MembershipProductListFilterOption {
  readonly membership_ids: string[];
}

/**
 * 멤버십 상품목록 "조회" 옵션. 필터와는 연관 없는 값
 */
export interface MembershipProductListRetrieveOption {
  readonly adult_check_needed: boolean;
  readonly limit?: number;
  readonly offset?: number;
}

/**
 * 멤버십 상품목록 "조회" 옵션. 필터와는 연관 없는 값
 */
export interface CreatorShopMembershipProductListRetrieveOption {
  readonly without_sold_out?: 'true' | 'false';
  readonly sort: ProductListTypeS.CreatorShopProductListSort;
  readonly membership_ids?: string;
  readonly offset?: number;
}

export interface MembershipProductData {
  product_id: number;
  link: string;
  name: string;
  price: number;
  image: string;
  image_ratio: number;
  type: MembershipProductType;
}

export interface MembershipProductItems {
  membership_id: ProductsMemberships['membership_id'];
  index: number;
  products: (MembershipProductData & {
    index: number;
    parent_index: number;
  })[];
}

export type GetMembershipProductListFunction = (
  pool: ReadDBConnectionType,
  mpsPool: MpsReadDBConnectionType,
  data: MembershipProductListFilterOption,
  option: MembershipProductListRetrieveOption,
) => Promise<MembershipProductItems[]>;

export type DeleteMembershipsByProductIdFunction = (
  pool: Readonly<WritePoolType>,
  product_id: Readonly<Products['id']>,
) => Promise<ProductsMemberships[]>;
